<script>
    import ReportsService from '../services/reports.service';
    import Toast from './Toast.svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let isIndividual = false;

    let indicatorsRemoved = function(response) {
		dispatch('indicatorsRemoved', {
			response : response,
		});
    }

    let removeIndicator = function() {
        ReportsService.removeKpiIndicator(getSelectedSections(), isIndividual).then(() => {
            indicatorsRemoved();
        });
    }

    const getSelectedSections = () => {
        const selectedFew = jQuery('.dragging');
        const fieldId = !isIndividual ? 'kpi_id' : 'op_employee_id';
        if (selectedFew.length) {
            const selectedSections = [];
            selectedFew.each(function() {
                selectedSections.push({
                    [fieldId]: jQuery(this).data('id'),
                    date: jQuery(this).data('date'),
                    field: jQuery(this).data('field')
                });
            });
            return selectedSections;
        } else {
            const selectedOne = jQuery('.cellSelected');
            return [{
                [fieldId]: selectedOne.data('id'),
                date: selectedOne.data('date'),
                field: selectedOne.data('field')
            }];
        }
    };

    let copyCells = function() {
		fireCopyEventFunction();
        jQuery("#dataCopied").toast('show')
        setTimeout(() => {
            jQuery("#dataCopied").toast('hide')
        }, 2000);
    }

    let emptyCells = function() {
		fireClearEventFunction();
    }
</script>
<Toast id="dataCopied" text="Data copied" class="success"></Toast>
<div class="dropdown float-right mr-2" id="selected-menu">
    <button class="btn btn-sm btn-outline-dark">
        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
    </button>

    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li on:click={removeIndicator} class="dropdown-item">
            <i class="fa fa-eraser"></i>
            Remove Indicator
        </li>

        <li on:click={copyCells} class="dropdown-item">
            <i class="fa fa-clone"></i>
            Copy Cells
        </li>

        <li on:click={emptyCells} class="dropdown-item">
            <i class="fa fa-trash-o"></i>
            Empty Cells
        </li>
    </ul>
</div>